import { FetchAPI } from '@philips-internal/oswald-ui-components';
import Controller, { OnChange, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { ChangeEvent, MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { FragmentNames, MaterialEducationalAliases } from '../../codegen';
import BaseController from '../BaseController';
import { Inject } from '@odinjs/odin';

import './material-education-controller.css';
import { APPLICATION_ROUTES } from '../../constants/application-routes';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { CardMaterialEducationAPI, CardMaterialEducationProps } from '@philips-emr/patient-components/src';

@Controller({ fragment: FragmentNames.MATERIAL_EDUCATIONAL })
export default class MaterialEducationController extends BaseController {

  @Inject(MaterialEducationalAliases.CARD_MATERIAL_EDUCATION_0)
    cardMaterialEducationAPI!: CardMaterialEducationAPI;

  @OnMount({target:MaterialEducationalAliases.MATERIAL_FETCH})
  onMountFetch(evt:MountEvent):void{
    const fetchApi = evt.target as FetchAPI;
    fetchApi.setParameters({ limit: 500, page: 0 });
    fetchApi.forceFetch();
  }

  @OnChange({target: 'material-segmented-control'})
  onClickCardMainPatient(evt:ChangeEvent<string>): void {
    const data =  evt.value[0] as unknown as CardMaterialEducationProps
    applicationContext.redirect(APPLICATION_ROUTES.MATERIAL_EDUCATIONAL_DETAIL, {nrSequence : data.nrSequencia});
  }

}